(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lx-creator-trust"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lx-trust-marquee')) {
  customElements.define('lx-trust-marquee', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.clip = this.querySelector('.lxtrust-scroll__clip');
      this.track = this.querySelector('.lxtrust-scroll__track');
      this.group = this.querySelector('.lxtrust-scroll__group');
      this.button = this.querySelector('.lxtrust-scroll__pause');
      if (!this.group || !this.group.children.length) return;
      this.manualPaused = false;
      this.hovered = false;
      this.inView = true;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hoverMedia = window.matchMedia('(hover: hover)');
      this.button.addEventListener('click', () => {
        this.manualPaused = !this.manualPaused;
        this.button.setAttribute('aria-pressed', String(this.manualPaused));
        this.button.setAttribute('aria-label', this.manualPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.button.firstElementChild.textContent = this.manualPaused ? '▶' : 'Ⅱ';
        this.updatePause();
      }, options);
      this.addEventListener('pointerenter', () => { this.hovered = this.hoverMedia.matches; this.updatePause(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.updatePause(); }, options);
      document.addEventListener('visibilitychange', () => this.updatePause(), options);
      this.reduced.addEventListener('change', () => { this.measure(); this.updatePause(); }, options);
      this.addEventListener('shopify:block:select', event => {
        this.dataset.editing = 'true';
        event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }, options);
      this.addEventListener('shopify:block:deselect', () => { delete this.dataset.editing; this.clip.scrollLeft = 0; }, options);
      this.clip.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (this.isConnected && !this.clip.contains(document.activeElement)) this.clip.scrollLeft = 0; });
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.group);
      this.resizeObserver.observe(this.clip);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.updatePause();
      });
      this.intersectionObserver.observe(this);
      this.measure();
      this.button.hidden = false;
      this.updatePause();
      document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
    }
    measure() {
      if (!this.isConnected) return;
      if (this.reduced.matches) {
        this.track.querySelectorAll('[data-lxt-copy]').forEach(copy => copy.remove());
        return;
      }
      const width = this.group.getBoundingClientRect().width;
      const viewport = this.clip.clientWidth;
      if (!width || !viewport) return;
      const copies = Math.max(1, Math.ceil(viewport / width));
      const existing = [...this.track.querySelectorAll('[data-lxt-copy]')];
      if (existing.length !== copies) {
        existing.forEach(copy => copy.remove());
        for (let index = 0; index < copies; index++) {
          const copy = this.group.cloneNode(true);
          copy.dataset.lxtCopy = 'true';
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('[data-shopify-editor-block]').forEach(item => item.removeAttribute('data-shopify-editor-block'));
          copy.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
          this.track.append(copy);
        }
      }
      const speed = Math.min(60, Math.max(20, Number(this.dataset.speed) || 32));
      this.style.setProperty('--lxt-distance', width + 'px');
      this.style.setProperty('--lxt-duration', width / speed + 's');
      this.dataset.ready = 'true';
    }
    updatePause() {
      this.dataset.paused = String(this.manualPaused || this.hovered || !this.inView || document.hidden || this.reduced.matches);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.track?.querySelectorAll('[data-lxt-copy]').forEach(copy => copy.remove());
      this.controller = null;
      delete this.dataset.ready;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-reference-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lxrh').forEach(header=>{header.addEventListener('keydown',event=>{if(event.key==='Escape'){header.querySelectorAll('details[open]').forEach(item=>{item.open=false;item.querySelector('summary').focus();});}});header.querySelectorAll('details').forEach(item=>{item.addEventListener('toggle',()=>{if(item.open){header.querySelectorAll('details[open]').forEach(other=>{if(other!==item)other.open=false;});}});});document.addEventListener('click',event=>{if(!header.contains(event.target))header.querySelectorAll('details[open]').forEach(item=>item.open=false);});});

if (!customElements.get('lx-header-cart')) {
  customElements.define('lx-header-cart', class extends HTMLElement {
    connectedCallback() {
      this.revision = 0;
      this.connect = () => {
        if (!this.unsubscribe && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => this.update(event.cartData));
        }
      };
      this.onPageShow = event => { if (event.persisted) this.update(); };
      this.connect();
      window.addEventListener('load', this.connect, { once: true });
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.unsubscribe = undefined;
      this.revision++;
      window.removeEventListener('load', this.connect);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    displayCount(count) {
      if (!Number.isInteger(count) || count < 0 || !this.isConnected) return;
      const badge = this.querySelector('.lxrh__count');
      const link = this.querySelector('a');
      if (!badge || !link) return;
      badge.textContent = String(count);
      badge.hidden = count === 0;
      link.setAttribute('aria-label', `${this.dataset.cartLabel} (${count})`);
    }

    async update(cart) {
      const revision = ++this.revision;
      if (Number.isInteger(cart?.item_count) && cart.item_count >= 0) {
        this.displayCount(cart.item_count);
        return;
      }
      const section = cart?.sections?.['cart-icon-bubble'];
      if (typeof section === 'string' && section.trim()) {
        const html = new DOMParser().parseFromString(section, 'text/html');
        if (html.querySelector('.shopify-section')) {
          const bubble = html.querySelector('.cart-count-bubble');
          const value = bubble?.querySelector('[aria-hidden="true"]')?.textContent.trim();
          if (!bubble || /^\d+$/.test(value || '')) {
            this.displayCount(bubble ? Number(value) : 0);
            return;
          }
        }
      }
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        const latest = await response.json();
        if (revision === this.revision) this.displayCount(latest.item_count);
      } catch {}
    }
  });
}

if (!customElements.get('lx-product-header')) {
 customElements.define('lx-product-header', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   const options = { signal: this.abort.signal };
   const header = this.closest('.lxrh');
   const toggle = this.querySelector('.lxrh__search-toggle');
   const search = header.querySelector('.lxrh__search input[type="search"]');
   const closeSearch = () => { header.removeAttribute('data-search-open'); toggle.setAttribute('aria-expanded','false'); };
   toggle.addEventListener('click', () => {
    const open = !header.hasAttribute('data-search-open');
    header.toggleAttribute('data-search-open',open);
    toggle.setAttribute('aria-expanded',String(open));
    header.querySelectorAll('details[open]').forEach(item => item.open = false);
    if(open) search.focus();
   }, options);
   header.addEventListener('keydown', event => {
    if(event.key === 'Escape' && header.hasAttribute('data-search-open')) { closeSearch(); toggle.focus(); }
   }, options);
   header.querySelector('.lxrh__locale').addEventListener('toggle', event => {
    if(event.target.open) header.style.setProperty('--lx-product-header-bottom',header.getBoundingClientRect().bottom + 'px');
   }, options);
   this.querySelector('.lxrh__back').addEventListener('click', event => {
    if(event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if(document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {event.preventDefault(); history.back();}
   }, options);
   this.observeGallery = () => {
    this.observer?.disconnect();
    const gallery = document.querySelector('.main-product .lx-product-mobile-gallery');
    if(!gallery) return;
    this.observer = new IntersectionObserver(entries => {
     header.toggleAttribute('data-gallery-passed',entries[0].boundingClientRect.bottom <= 56);
    },{rootMargin:'-56px 0px 0px 0px'});
    this.observer.observe(gallery);
   };
   if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',this.observeGallery,{...options,once:true});
   else this.observeGallery();
   document.addEventListener('shopify:section:load',this.observeGallery,options);
  }
  disconnectedCallback(){ this.abort?.abort(); this.observer?.disconnect(); }
 });
}
if (!customElements.get('c-opt-desktop-nav')) {
 customElements.define('c-opt-desktop-nav',class extends HTMLElement {
  connectedCallback(){
   this.abort=new AbortController();
   const options={signal:this.abort.signal};
   const desktop=matchMedia('(min-width:990px)');
   const items=[...this.querySelectorAll('.lxrh__nav>.lxrh__dropdown')];
   let timer;
   const cancel=()=>clearTimeout(timer);
   const close=()=>items.forEach(item=>item.open=false);
   const open=item=>{cancel();items.forEach(other=>other.open=other===item);};
   items.forEach(item=>{
    item.addEventListener('pointerenter',event=>{if(!desktop.matches||event.pointerType!=='mouse')return;cancel();timer=setTimeout(()=>open(item),100);},options);
    item.addEventListener('pointerleave',event=>{if(!desktop.matches||event.pointerType!=='mouse')return;cancel();timer=setTimeout(()=>{if(!item.contains(document.activeElement))item.open=false;},220);},options);
    item.addEventListener('focusout',()=>{queueMicrotask(()=>{if(desktop.matches&&!item.contains(document.activeElement)&&!item.matches(':hover'))item.open=false;});},options);
   });
   this.querySelectorAll('.lxrh__nav>a').forEach(link=>link.addEventListener('pointerenter',()=>{if(desktop.matches){cancel();close();}},options));
   this.addEventListener('keydown',event=>{if(!desktop.matches||event.key!=='Escape')return;cancel();const item=items.find(item=>item.open);if(item){event.preventDefault();event.stopImmediatePropagation();close();item.querySelector('summary').focus();}}, {...options,capture:true});
   this.addEventListener('toggle',event=>{if(!desktop.matches||!event.target.open)return;this.querySelectorAll('details[open]').forEach(other=>{if(other!==event.target)other.open=false;});},{...options,capture:true});
   document.addEventListener('click',event=>{if(desktop.matches&&!this.contains(event.target)){cancel();close();} },options);
   desktop.addEventListener('change',()=>{cancel();close();},options);
   this.clearTimer=cancel;
  }
  disconnectedCallback(){this.abort?.abort();this.clearTimer?.();}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-reference-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lx-category-tabs')){customElements.define('lx-category-tabs',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.tabs=Array.from(this.querySelectorAll('[role=tab]'));this.panels=Array.from(this.querySelectorAll('[role=tabpanel]'));if(!this.tabs.length)return;this.dataset.ready='true';this.querySelector('[role=tablist]').hidden=false;this.select(0,false);this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.select(index,false));tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;else if(event.key==='ArrowLeft')next=(index-1+this.tabs.length)%this.tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else return;event.preventDefault();this.select(next,true);});});this.addEventListener('shopify:block:select',event=>{const index=this.panels.findIndex(panel=>panel===event.target||panel.contains(event.target));if(index>=0)this.select(index,false);});}select(index,focus){this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index;});if(focus)this.tabs[index].focus();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-standee-configurator"]) return;
  try {
    
  if (!customElements.get('lx-standee-configurator')) {
    customElements.define('lx-standee-configurator', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.form = this.querySelector('form');
        this.quantity = this.form.elements.quantity;
        this.selects = [...this.querySelectorAll('[data-option]')];
        this.cards = [...this.querySelectorAll('[data-tier]')];
        this.cartItems = [];
        this.cartReady = false;
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency || 'USD'});
        this.selects.forEach(select => select.addEventListener('change', () => this.update()));
        this.quantity.addEventListener('input', () => this.update());
        this.quantity.addEventListener('change', () => this.update());
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
          this.quantity.value = Math.max(1,Math.min(99999,(Number(this.quantity.value)||1)+Number(button.dataset.step)));
          this.update();
        }));
        this.cards.forEach(button => button.addEventListener('click', () => {
          this.quantity.value = Math.max(1,Number(button.dataset.tier)-this.existingQuantity());
          this.update();
        }));
        this.form.addEventListener('submit', async event => {
          event.preventDefault();
          if (this.submitting) return;
          this.submitting = true;
          await this.refreshCart();
          this.update();
          if (!this.cartReady || !this.variant || !this.variant.available || !this.quantity.checkValidity()) {
            this.submitting = false;
            this.form.reportValidity();
            return;
          }
          HTMLFormElement.prototype.submit.call(this.form);
        });
        this.refreshHandler = () => this.refreshCart();
        this.visibilityHandler = () => { if (!document.hidden) this.refreshCart(); };
        window.addEventListener('pageshow',this.refreshHandler);
        document.addEventListener('visibilitychange',this.visibilityHandler);
        this.update();
        this.refreshCart();
      }
      disconnectedCallback() {
        window.removeEventListener('pageshow',this.refreshHandler);
        document.removeEventListener('visibilitychange',this.visibilityHandler);
      }
      async refreshCart() {
        try {
          const response = await fetch(this.dataset.cartUrl,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          this.cartItems = cart.items || [];
          this.cartReady = true;
          this.querySelector('[data-cart-error]').hidden = true;
        } catch {
          this.cartReady = false;
          this.querySelector('[data-cart-error]').hidden = false;
        }
        this.update();
      }
      existingQuantity() {
        return this.variant ? this.cartItems.reduce((sum,item) => sum+(String(item.variant_id)===String(this.variant.id) ? Number(item.quantity) : 0),0) : 0;
      }
      unitCents(variant, quantity) {
        let price = variant.price;
        for (const tier of variant.tiers || []) {
          if (quantity >= Number(tier.min_qty)) price = Math.round(Number(tier.unit_price)*100);
        }
        return price;
      }
      update() {
        this.variant = this.variants.find(variant => variant.options.every((value,index) => value === this.selects[index].value));
        const quantity = Number(this.quantity.value);
        const valid = this.variant && this.variant.available && Number.isInteger(quantity) && quantity >= 1 && quantity <= 99999;
        this.querySelectorAll('[data-add]').forEach(button => button.disabled = !valid || !this.cartReady);
        this.querySelector('[data-error]').hidden = Boolean(valid);
        if (!this.variant) return;
        this.querySelector('[data-variant-id]').value = this.variant.id;
        const url = new URL(location.href);
        url.searchParams.set('variant',this.variant.id);
        history.replaceState(null,'',url);
        const q = valid ? quantity : 1;
        const existing = this.existingQuantity();
        const combined = existing+q;
        const unit = this.unitCents(this.variant,combined);
        const note = this.querySelector('[data-cart-note]');
        note.hidden = existing===0;
        note.textContent = note.dataset.pattern.replace('{existing}',String(existing)).replace('{combined}',String(combined));
        this.querySelector('[data-unit-price]').textContent = this.money.format(unit/100);
        this.querySelectorAll('[data-total]').forEach(total => total.textContent = this.money.format(unit*q/100));
        this.cards.forEach((card,index) => {
          const minimum = Number(card.dataset.tier);
          const next = this.cards[index+1] ? Number(this.cards[index+1].dataset.tier) : Infinity;
          const active = combined >= minimum && combined < next;
          card.setAttribute('aria-pressed',String(active));
          card.querySelector('[data-tier-price]').textContent = this.money.format(this.unitCents(this.variant,Math.max(minimum,existing+1,active ? combined : minimum))/100);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-video-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lx-video-gallery')){
  customElements.define('lx-video-gallery',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.track=this.querySelector('.lxvideos__track');
      this.querySelector('.lxvideos__navigation').hidden=false;
      this.mobilePosters=window.matchMedia('(max-width: 749px)');
      this.loadPoster=button=>{
        const source=button.querySelector('source[data-lx-mobile-poster]');
        const image=button.querySelector('img');
        if(!source||!image)return;
        source.sizes=image.sizes;
        source.srcset=image.srcset||image.src;
        source.removeAttribute('data-lx-mobile-poster');
        image.loading='eager';
        this.posterObserver?.unobserve(button);
      };
      const watchPosters=()=>{
        this.posterObserver?.disconnect();
        if(!this.mobilePosters.matches)return;
        const buttons=Array.from(this.querySelectorAll('source[data-lx-mobile-poster]'),source=>source.closest('.lxvideos__poster'));
        if('IntersectionObserver' in window){
          this.posterObserver=new IntersectionObserver(entries=>{
            if(!this.mobilePosters.matches)return;
            entries.forEach(entry=>{if(entry.isIntersecting)this.loadPoster(entry.target);});
          },{rootMargin:'200px 0px'});
          buttons.forEach(button=>this.posterObserver.observe(button));
        }else{
          buttons.forEach(this.loadPoster);
        }
      };
      this.mobilePosters.addEventListener('change',watchPosters,options);
      this.addEventListener('focusin',event=>{
        const button=event.target.closest('.lxvideos__poster');
        if(button&&this.mobilePosters.matches)this.loadPoster(button);
      },options);
      watchPosters();
      this.updateButtons=()=>{const max=this.track.scrollWidth-this.track.clientWidth;this.querySelector('[data-direction="-1"]').disabled=this.track.scrollLeft<2;this.querySelector('[data-direction="1"]').disabled=this.track.scrollLeft>=max-2;};
      this.addEventListener('click',event=>{
        const move=event.target.closest('[data-direction]');
        if(move){this.track.scrollBy({left:Number(move.dataset.direction)*this.track.clientWidth,behavior:'auto'});return;}
        const button=event.target.closest('[data-load-video]');
        if(!button)return;
        const media=button.closest('.lxvideos__media');
        const player=media.querySelector('template').content.querySelector('video').cloneNode(true);
        this.querySelectorAll('video').forEach(video=>video.pause());
        button.replaceWith(player);
        player.tabIndex=0;
        player.focus({preventScroll:true});
        this.observer?.observe(player);
        player.play().catch(()=>{});
      },options);
      this.addEventListener('play',event=>{if(event.target.tagName==='VIDEO')this.querySelectorAll('video').forEach(video=>{if(video!==event.target)video.pause();});},{capture:true,signal:this.controller.signal});
      this.track.addEventListener('scroll',this.updateButtons,{passive:true,signal:this.controller.signal});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.querySelectorAll('video').forEach(video=>video.pause());},options);
      if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)entry.target.pause();}),{threshold:0});}
      if('ResizeObserver' in window){this.resizeObserver=new ResizeObserver(this.updateButtons);this.resizeObserver.observe(this.track);}
      this.updateButtons();
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.posterObserver?.disconnect();this.resizeObserver?.disconnect();this.querySelectorAll('video').forEach(video=>video.pause());}
  });
}

  } catch(e) { console.error(e); }
})();
})();
